import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import StockChart from '../components/StockChart';
import './PageIndustriaAnio.css';

const DATA = [
  { year: 2016, value: 6196565 },
  { year: 2017, value: 10277529 },
  { year: 2018, value: 8872327 },
  { year: 2019, value: 8504644 },
  { year: 2020, value: 5814378 },
  { year: 2021, value: 8674187 },
  { year: 2022, value: 5877290 },
  { year: 2023, value: 17226956 },
  { year: 2024, value: 20975800 },
  { year: 2025, value: 28517929 },
];

const EVENTS = [
  { year: 2017, label: 'JOH Anuncia Reelecci\u00f3n' },
  { year: 2020, label: 'COVID-19' },
  { year: 2022, label: 'Xiomara Castro' },
];

function PageMedioOOH() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="industria-page">
        <header className="industria-header">
          <button className="btn-back" onClick={() => navigate('/medio-prensa')}>
            &#8592; Prensa
          </button>
          <div className="industria-title-block">
            <h1 className="industria-title">Outdoor (OOH)</h1>
            <p className="industria-subtitle">Inversi&oacute;n publicitaria &middot; Outdoor &middot; Honduras 2016–2025 &middot; USD</p>
          </div>
          <button className="btn-next" onClick={() => navigate('/top-10-tv')}>
            Siguiente &#8594;
          </button>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <StockChart data={DATA} color="#fbbf24" events={EVENTS} />

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageMedioOOH;
